import React, { Component } from 'react';
import Main from './components/Main';
import Header from './components/header/Header';
import Footer from './components/Footer';
import Favicon from 'react-favicon';
import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';

class App extends Component {

  componentWillMount()
  {
    document.title = "SCHelper";
  }

   changeFavicon(src) {

     var link = document.createElement('link'),
         oldLink = document.getElementById('dynamic-favicon');
     link.id = 'dynamic-favicon';
     link.rel = 'shortcut icon';
     link.href = src;
     if (oldLink) {
      document.head.removeChild(oldLink);
     }
     document.head.appendChild(link);
  }


  render() {
    return (

      <div className="SCH-body">
        <Favicon url="https://staging.soundcloudhelper.com/wp-content/themes/sch/favicon-32x32.png"/>

        <Header/>

        <div className="main-content">
          <Main />
        </div>

        <Footer />
      </div>
    );

  }

}

export default App;
